/* Présentation uniquement : aucune écriture des variantes, prix, images ou formulaires. */
(() => {
  'use strict';
  if (window.SomnilaSn32ProductUX) return;

  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  const roots = '[data-sn17-product], [data-sn17-card]';

  class ImageTransition {
    constructor(root, image) {
      this.root = root;
      this.image = image;
      this.source = image.getAttribute('src') || '';
      this.pendingSource = '';
      this.animation = null;
      this.frame = null;
      this.abort = new AbortController();

      image.addEventListener('load', () => this.loaded(), { signal: this.abort.signal });
      image.addEventListener('error', () => this.cancel(), { signal: this.abort.signal });
      this.observer = new MutationObserver(() => this.sourceChanged());
      this.observer.observe(image, { attributes: true, attributeFilter: ['src'] });
    }

    sourceChanged() {
      const source = this.image.getAttribute('src') || '';
      if (source === this.source) return;
      this.cancel();
      this.source = source;
      if (!source || this.image.hidden || motion.matches) return;
      this.pendingSource = source;

      // Une image en cache peut être déjà chargée avant le prochain événement load.
      if (this.image.complete && this.image.naturalWidth > 0) {
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.loaded();
        });
      }
    }

    loaded() {
      if (!this.pendingSource || this.pendingSource !== this.image.getAttribute('src')) return;
      if (!this.root.isConnected || this.image.hidden || !this.image.complete || !this.image.naturalWidth) return;
      this.pendingSource = '';
      if (motion.matches || typeof this.image.animate !== 'function') return;

      // Aucune disparition pendant le chargement : seule la nouvelle image chargée s’anime.
      this.animation?.cancel();
      const animation = this.image.animate([{ opacity: 0.65, scale: '1.015' }, { opacity: 1, scale: '1' }], {
        duration: 360,
        easing: 'cubic-bezier(.22,1,.36,1)'
      });
      this.animation = animation;
      animation.finished.then(() => {
        if (this.animation === animation) this.animation = null;
      }).catch(() => {});
    }

    cancel() {
      this.pendingSource = '';
      if (this.frame !== null) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.animation?.cancel();
      this.animation = null;
    }

    destroy() {
      this.cancel();
      this.abort.abort();
      this.observer.disconnect();
    }
  }

  function initialise(scope) {
    const candidates = [...scope.querySelectorAll(roots)];
    if (scope.matches?.(roots)) candidates.unshift(scope);
    candidates.forEach(root => {
      if (instances.has(root)) return;
      const selector = root.matches('[data-sn17-product]') ? '[data-sn17-main-image]' : '[data-card-image]';
      const image = root.querySelector(selector);
      if (image) instances.set(root, new ImageTransition(root, image));
    });
  }

  function destroy(scope) {
    instances.forEach((instance, root) => {
      if (root === scope || scope.contains(root)) {
        instance.destroy();
        instances.delete(root);
      }
    });
  }

  window.SomnilaSn32ProductUX = { initialise, destroy };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
  } else initialise(document);

  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => destroy(event.target));
  const stopMotion = () => {
    if (motion.matches) instances.forEach(instance => instance.cancel());
  };
  if (motion.addEventListener) motion.addEventListener('change', stopMotion);
  else motion.addListener(stopMotion);
})();
